import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  virtualOfficeServiceUrl = '';
  backOfficeServiceUrl = '';
  virtualOfficeFront = '';
  visorGIS = '';
  portalWebUrl = '';
  clientAttentionCenterUrl = '';
  infobitUrl = '';
  naturalGasConnectionUrl = '';
  captchaKey = '';
  captchaKeyV3='';
  publicPaymentKeySoles = '';
  publicPaymentKeyDolares = '';
  paymentEndpoint = '';
  usernameValidatorService = '';
  passwordValidatorService = '';
  urlValidatorService = '';
  encryptEnabled = '';
  apiKeyGoogleMap = '';
  softnetUrl='';
  urlTiendaCatalogo='';
  urlTiendaVtex='';
  constructor() { }
}
